import { APPOINTMENT_REQUEST_CALENDAR, APPOINTMENT_REQUEST_FORM, SCREEN } from '../../utils/constants';
import { appointmentChannelId, fileUploadChannel, form, leadInfo, preQuestionnairePhotosDone, selectedAppointmentUnixTime } from '../../utils/variables';
import { clearCustomFields } from '../actions/consultActions';
import { uploadPhotosListeners } from './uploadPhotosListeners';
import { navigate, openBookAppointment } from './movePages';
import { verifyInforListeners } from './verifyInforListenters';
import { appointmentItemsClickEventHandler } from '../actions/selectTimeActions';

export async function navigateToNextPage() {
    const appointmentRequestType = form.appointment_request_type;
    if (appointmentRequestType === APPOINTMENT_REQUEST_CALENDAR) {
        if (appointmentChannelId && leadInfo) {
            // Questionnaire ran before calendar — no time selected yet, go to calendar
            if (!selectedAppointmentUnixTime && form?.appointment_channel?.show_questionnaire_before_scheduling) {
                openBookAppointment();
                return;
            }
            await appointmentItemsClickEventHandler(selectedAppointmentUnixTime, leadInfo);
        } else {
            navigate(SCREEN.VERIFY_INFORMATION);
            verifyInforListeners(leadInfo);
        }
    } else {
        if (fileUploadChannel && !preQuestionnairePhotosDone) {
            uploadPhotosListeners();
            navigate(SCREEN.UPLOAD_PHOTOS);
        } else {
            navigate(SCREEN.THE_END);
        }
    }
}

export async function navigateToNextPageWithClearFields() {
    const apiRequestType = form.appointment_request_type;
    let appointmentRequestType = apiRequestType === APPOINTMENT_REQUEST_FORM
        ? APPOINTMENT_REQUEST_FORM
        : (appointmentChannelId ? APPOINTMENT_REQUEST_CALENDAR : apiRequestType);
    if (appointmentRequestType === APPOINTMENT_REQUEST_CALENDAR) {
        if (appointmentChannelId && leadInfo) {
            // Questionnaire ran before calendar — no time selected yet, go to calendar
            if (!selectedAppointmentUnixTime && form?.appointment_channel?.show_questionnaire_before_scheduling) {
                openBookAppointment();
                return;
            }
            await appointmentItemsClickEventHandler(selectedAppointmentUnixTime, leadInfo);
        } else {
            navigate(SCREEN.VERIFY_INFORMATION);
            verifyInforListeners(leadInfo);
        }
    } else {
        if (fileUploadChannel && !preQuestionnairePhotosDone) {
            uploadPhotosListeners();
            navigate(SCREEN.UPLOAD_PHOTOS).finally(() => {
                clearCustomFields();
            });
        } else {
            navigate(SCREEN.THE_END).finally(() => {
                clearCustomFields();
            });
        }
    }
}
